var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"liquidity-pool"},[_c('img',{attrs:{"src":require(("../assets/" + (_vm.fromCurrency.toLowerCase()) + ".svg")),"alt":"currency icon"}}),_c('h3',[_vm._v(_vm._s(_vm.fromCurrency))])])}
var staticRenderFns = []

export { render, staticRenderFns }